export default "__VITE_ASSET__CxqUHsWa__"